
import axios from "axios";
import { path } from "../navigation/path";

const axiosInstance = axios.create({
  baseURL: "/",

  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },


  (error) => {

    return Promise.reject(error);
  }

);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("member_id");
      localStorage.removeItem("zone_admin_zone_ids");
      localStorage.removeItem("permissions");
      localStorage.removeItem("roleEntity");
      localStorage.removeItem("isSuperAdmin");
      window.location.href = path.LOGIN;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
